var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.831 68.2118C67.9053 68.2118 69.5869 66.5262 69.5869 64.4471C69.5869 62.3679 67.9053 60.6824 65.831 60.6824C63.7567 60.6824 62.0751 62.3679 62.0751 64.4471C62.0751 66.5262 63.7567 68.2118 65.831 68.2118Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5869 91.8541C69.5869 93.9333 67.9053 95.6188 65.831 95.6188C63.7567 95.6188 62.0751 93.9333 62.0751 91.8541C62.0751 89.7749 63.7567 88.0894 65.831 88.0894C67.9053 88.0894 69.5869 89.7749 69.5869 91.8541Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.831 123.026C67.9053 123.026 69.5869 121.34 69.5869 119.261C69.5869 117.182 67.9053 115.496 65.831 115.496C63.7567 115.496 62.0751 117.182 62.0751 119.261C62.0751 121.34 63.7567 123.026 65.831 123.026Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6291 64.4471C96.6291 66.5262 94.9476 68.2118 92.8732 68.2118C90.7989 68.2118 89.1174 66.5262 89.1174 64.4471C89.1174 62.3679 90.7989 60.6824 92.8732 60.6824C94.9476 60.6824 96.6291 62.3679 96.6291 64.4471Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.915 68.2118C121.99 68.2118 123.671 66.5262 123.671 64.4471C123.671 62.3679 121.99 60.6824 119.915 60.6824C117.841 60.6824 116.16 62.3679 116.16 64.4471C116.16 66.5262 117.841 68.2118 119.915 68.2118Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3052 142C15.4798 142 14 140.517 14 138.687V17.3129C14 15.4833 15.4798 14 17.3052 14H138.695C140.52 14 142 15.4833 142 17.3129V138.687C142 140.517 140.52 142 138.695 142H17.3052ZM24.216 131.76V87.4871L44.6479 87.4871V131.76H24.216ZM44.6479 77.2471L24.216 77.2471V24.24H53.061V43.8165H51.2582C47.6074 43.8165 44.6479 46.783 44.6479 50.4424V77.2471ZM63.277 43.8165H93.6244V24.24H63.277V43.8165ZM103.84 43.8165V24.24H131.784V43.8165H103.84ZM131.784 54.0565V131.76H54.8639V54.0565H131.784Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraming);
export default __webpack_public_path__ + "static/media/framing.95378b46d2425f2b6c135a32d397ce7d.svg";
export { ForwardRef as ReactComponent };